// extracted by mini-css-extract-plugin
module.exports = {"container":"YearSwitcher_container__fcPzF","year":"YearSwitcher_year__3NlNA","active":"YearSwitcher_active__3uB6W"};